module.exports = function() {
  return new Worker(__webpack_public_path__ + "36bf0895e3481d6b0ba4.worker.js");
};